import { Box, Divider } from '@material-ui/core';
import { memo, useCallback, useState } from 'react';
import Hidden from './HiddenSSRCompatible';

export const useTabChangeHelper = () => {
  const [tabSelectedIndex, setTabSelectedIndex] = useState(0);

  const handleTabChange = useCallback((event, newValue) => {
    setTabSelectedIndex(newValue);
  }, []);

  return { handleTabChange, tabSelectedIndex };
};

export const TabPanel = memo(function TabPanel(props) {
  const { children, value, index, noPadding } = props;

  return value === index ? (
    <>
      <Divider />
      <Hidden smDown>
        <Box p={noPadding ? 0 : 5}>{children}</Box>
      </Hidden>
      <Hidden mdUp>
        <Box p={noPadding ? 0 : 3}>{children}</Box>
      </Hidden>
    </>
  ) : null;
});
